import React from 'react'
import { useLocale } from '../../hooks';
import { mapLocale } from '../../utils/mapping';
export const useLocalePath = (slug) => {
    const locale = useLocale()
    if (slug[slug.length - 1] === '/') return `/${mapLocale[locale]}${slug}`
    else if (slug === '') return `/${mapLocale[locale]}`
    else if (slug === '/') return `/${mapLocale[locale]}`
    else return `/${mapLocale[locale]}${slug}/`
}